import { Col, Row } from "react-bootstrap";
import { FiHome } from "react-icons/fi";
import {
  MdOutlineCategory,
  MdOutlineChat,
  MdOutlineSettingsPower,
  MdOutlineShoppingBag,
  MdOutlineDashboardCustomize,
} from "react-icons/md";
import { RiShieldUserLine } from "react-icons/ri";

const AccountContent = ({
  children,
  bg = "white",
  title,
  router,
  header = true,
  subtitle,
  extra,
}) => {
  const activeElem = Menus.find((s) => s.href === router.pathname);

  return (
    <Col sm="9">
      <div className={`bg-${bg} rounded-8`}>{children}</div>
    </Col>
  );
};
export default AccountContent;

const Menus = [
  {
    title: "My Orders",
    icon: <MdOutlineShoppingBag />,
    href: "/account/order",
  },
  {
    title: "My Profile",
    icon: <RiShieldUserLine />,
    href: "/account",
  },
  {
    title: "Services",
    icon: <MdOutlineCategory />,
    href: "/account/service",
  },
  {
    title: "My Address",
    icon: <FiHome />,
    href: "/account/address",
  },
  {
    title: "My Chats",
    icon: <MdOutlineChat />,
    href: "/account/chat",
  },
  {
    title: "Requests",
    icon: <MdOutlineDashboardCustomize />,
    href: "/account/request",
  },
  {
    title: "Sign Out",
    icon: <MdOutlineSettingsPower />,
    href: "/signout",
  },
];
